import React from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

const ConfirmModal = ({
    isOpen = false,
    title = '',
    content,
    onValidate = () => {},
    onReject = () => {},
    onClose = () => { },
}) => {
    return (
        <Dialog
            fullWidth
            maxWidth='sm'
            open={isOpen}
            onClose={onClose}
        >
            <DialogTitle sx={{ borderBottom: 'none', backgroundColor: 'white', color: 'black' }}>{title}</DialogTitle>
            {!isNil(content) && <DialogContent>{content}</DialogContent>}
            <DialogActions sx={{ borderTop: 'none' }}>
                <Button
                    onClick={() => {
                        onReject()
                        onClose()
                    }}
                    variant='outlined'
                >
                    Non
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    Oui
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.node,
    onValidate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onReject: PropTypes.func,
}

export default ConfirmModal